var filterRecipes = function(filterAll, itemsAttr, filterAttr) {
  $('.filter').on('click', function (e) {
    var filter = $(e.target).attr(filterAttr);
    var currentFilter = $('.filter-button.active').attr(filterAttr);

    if (!filter || currentFilter === filter) {
      return
    }

    $('.filter-button.active').removeClass('active');
    $(e.target).addClass('active');

    var items = $('.recipe-item');
    currentFilter = filter;

    if (filter === filterAll) {
      items.each(function (idx, item) {
        $(item).removeClass('hidden');
      });
    } else {
      items.each(function (idx, item) {
        var type = $(item).attr(itemsAttr);

        if (type !== currentFilter) {
          $(item).addClass('hidden');
        } else {
          $(item).removeClass('hidden');
        }
      });
    }
  });
}

module.exports = filterRecipes
